export default __webpack_public_path__ + "static/media/icon_arrow-breadcrumbs.9e509720.svg";